<script>
import firebase from '@firebase/app'
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  data(){
    return{
        year_path: '',
        month_path:'',
        day_path: '',
        testData: [],
        totalLength: 0,
        chartdata: {
        labels: [],
        datasets: [
          {
            type: 'bar',
            yAxisID: "y-axis-1",
            label: '文字数',
            backgroundColor: '#A7CEE3',
            data: []
          },
          {
              type: 'line', // 追加
              label: '累計文字数',
              yAxisID: "y-axis-2",
              data: [],
              fill: false,
              borderColor : "#B2DF8A",
              backgroundColor : "#B2DF8A",
          },
        ]
      },
      options:{
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            id: "y-axis-1",   // Y軸のID
            type: "linear",
            position: "left", // どちら側に表示される軸か？
            ticks: {
              min: 0,
            }            
          },
          {
            id: "y-axis-2",
            type: "linear",
            position: "right",
            ticks: {
              beginAtZero: true,
            }
          }],
        },
        layout: { //レイアウトの設定
          padding: {
            left: 5,
            right: 5,
            top: 0,
            bottom: 0
          }
        }
      },
    }
  },
  computed:{
    user(){
      return this.$store.getters.user;
    },
  },
  created(){
    //月の日数取得
    var [ , , year_path, month_path, day_path] = location.pathname.split('/')
    this.year_path = year_path
    this.month_path = month_path
    this.day_path = day_path

    firebase.firestore().collection('diary_text').doc(this.user.uid).collection(year_path + '_' + month_path).doc(String(day_path)).get().then((doc) => {
      var data = doc.data()
      for (var key  in data.writing_info){
        this.chartdata.labels.push(key + "分");
        this.chartdata.datasets[0].data.push(data.writing_info[key].length)
        this.totalLength = this.totalLength + data.writing_info[key].length
        this.chartdata.datasets[1].data.push(this.totalLength)
      }
    }).then(()=>{
      this.renderChart(this.chartdata, this.options)
    })
  }
}

</script>